import { createFileRoute } from '@tanstack/react-router'

import type { Language } from '@orus.eu/translations'

import { SignRenewalPage } from '../../../../components/pages/sign-renewal-page.tsx'

export const Route = createFileRoute('/s/e/$token')({
  component: SignRenewalPage,
  validateSearch: (search: Record<string, unknown>) => ({
    lg: search['lg'] as Language | undefined,
  }),
})
